import React from 'react'
import PropTypes from 'prop-types'
import { hooks as i18nHooks } from 'mage-i18n'
import {
  ButtonSecondary,
  ParagraphSecondary,
  SpacerVertical,
  TitlePrimary
} from 'mage-deps/@klarna/bubble-ui'
import { hooks as coreHooks } from 'mage-core'
import useHelpContext from '../hooks/useHelpContext'
import { EducationAnalytics, useEducationAnalytics } from 'education-tools'
import { useHistory } from 'react-router-dom'

ViewTicketPage.propTypes = {
  ticketId: PropTypes.number.isRequired
}

export default function ViewTicketPage({ ticketId }) {
  const { reset } = useHelpContext()
  const t = i18nHooks.useTranslator()
  const tokenHelper = coreHooks.useTokenHelper()
  const email = tokenHelper.getEmail()
  const history = useHistory()

  const trackClick = useEducationAnalytics({
    category: 'uhqm/page/view-support-ticket/view-button',
    action: 'click',
    label: ticketId
  })

  return (
    <div data-testid="view-ticket-page">
      <EducationAnalytics
        category="uhqm/page/view-support-ticket"
        action="pageview"
        label={ticketId}
      />

      <TitlePrimary>{t('hqm.support-page.view-ticket.title')}</TitlePrimary>
      <SpacerVertical small />
      <ParagraphSecondary data-testid="ticket-details">
        <span data-testid="ticket-details-description">
          {t('hqm.support-page.view-ticket.details')}
        </span>
        <br />
        <span data-testid="ticket-details-id">
          {t('hqm.support-page.view-ticket.ticket', { ticketId })}
        </span>
        <br />
        <span data-testid="ticket-details-email">
          {t('hqm.support-page.view-ticket.email', { email })}
        </span>
      </ParagraphSecondary>
      <SpacerVertical small />
      <ParagraphSecondary>{t('hqm.support-page.view-ticket.status')}</ParagraphSecondary>
      <ParagraphSecondary>
        <ButtonSecondary size="medium" data-testid="view-ticket-link" onClick={onClick}>
          {t('hqm.support-page.view-ticket.track')}
        </ButtonSecondary>
      </ParagraphSecondary>
    </div>
  )

  function onClick() {
    trackClick()
    reset()

    const target = `/support/ticket/${ticketId}`

    if (window.location.pathname.startsWith('/support')) {
      history.push(target)
    } else {
      setTimeout(() => {
        window.location = target
      }, 300)
    }
  }
}
